import React, { useEffect, useRef, useState } from "react"
import { ADD_NOTE } from "../graphql/AddNote"
import { useMutation } from "@apollo/client"
import { Editor } from "react-draft-wysiwyg"
import { EditorState, convertToRaw } from "draft-js"
import draftToHtml from "draftjs-to-html"
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"
import { AiFillCheckCircle, AiFillCloseCircle } from "react-icons/ai"
import Loading from "./Loading"

interface Iprops {
  setShowCreate: React.Dispatch<React.SetStateAction<boolean>>
  showCreate: boolean
  userId: string | undefined
  refetch: any
}

const Create: React.FC<Iprops> = ({
  showCreate,
  setShowCreate,
  userId,
  refetch,
}) => {
  const divRef = useRef<HTMLDivElement>(null)
  const [editorState, setEditorState] = useState<EditorState>(
    EditorState.createEmpty()
  )
  const [title, setTitle] = useState<string>("")
  const [keywords, setKeywords] = useState<string>("")
  const [content, setContent] = useState<string>("")

  const [addNoteMutation, { error, loading }] = useMutation(ADD_NOTE)

  useEffect(() => {
    showCreate
      ? divRef.current?.classList.remove("translate-x-full")
      : divRef.current?.classList.add("translate-x-full")
  }, [showCreate])

  const addNoteHandle = () => {
    if (title.trim().length <= 0) return
    addNoteMutation({
      variables: {
        title: title,
        keyword: keywords,
        content: content,
        userId: userId,
      },
    })
      .then((res) => {
        if (res) {
          setEditorState(EditorState.createEmpty())
          setShowCreate(false)
          refetch()
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }

  if (loading) return <Loading />
  if (error) return <div>Somethig Went Wrong...</div>

  return (
    <div
      className="fixed inset-0 z-30 mb-40 text-xs transition-all duration-300 translate-x-ful sm:text-sm sm:mb-24"
      ref={divRef}
    >
      <div className=" relative grid grid-cols-1 grid-rows-[auto_auto_auto_1fr] h-full p-2 bg-slate-600">
        <h2 className="mt-4 text-2xl text-center">Create</h2>
        <div className="flex flex-col p-2 px-8 space-y-2">
          <input
            className="p-1 px-4 text-sm border-2 rounded-sm outline-none md:text-lg focus:outline-slate-400 bg-inherit border-slate-500"
            type="text"
            placeholder="Title"
            onChange={(e) => setTitle(e.target.value)}
          />
          <input
            className="p-1 px-4 text-sm border-2 rounded-sm outline-none md:text-lg focus:outline-slate-400 bg-inherit border-slate-500"
            type="text"
            placeholder="Keywords"
            onChange={(e) => setKeywords(e.target.value)}
          />
        </div>
        {/* buttons */}
        <div className="flex justify-end px-5 py-1 space-x-1">
          <button
            type="button"
            className="w-8 h-8 grid place-content-center text-[8px] p-1 text-green-500 border-2 rounded-full bg-slate-700 border-slate-400 hover:text-green-200"
            onClick={() => {
              addNoteHandle()
            }}
          >
            <AiFillCheckCircle className="text-4xl" />
          </button>
          <button
            type="button"
            className="w-8 h-8  grid place-content-center text-[8px] p-1 text-red-500 border-2 rounded-full bg-slate-700 border-slate-400 hover:text-red-400"
            onClick={() => {
              setShowCreate(false)
            }}
          >
            <AiFillCloseCircle className="text-4xl " />
          </button>
        </div>
        <Editor
          wrapperClassName="min-h-full"
          toolbarClassName="text-black p-2 rounded text-xs"
          editorClassName="text-black cursor-text rounded shadow-md shadow-slate-300  bg-orange-50 md:p-4 p-2 "
          placeholder="Begin typing ..."
          editorState={editorState}
          onEditorStateChange={(newState) => {
            const rawDraftjs = convertToRaw(newState.getCurrentContent())
            const convertedToHtml = draftToHtml(rawDraftjs)
            setContent(convertedToHtml)
            setEditorState(newState)
          }}
          toolbar={{
            options: [
              "inline",
              "blockType",
              "fontSize",
              "fontFamily",
              "list",
              "textAlign",
              "colorPicker",
              "emoji",
              "image",
            ],
          }}
        />
      </div>
    </div>
  )
}

export default Create
